import { h, Component } from 'preact';
import style from './style'
import dayjs from 'dayjs'
import {Container} from 'components/elements'

export default (props)=>{
	return (
		<div onClick={props.onSelect} class={style.select}>
			<Container selected={props.selected}>
					<div class={style.icon}>
						<i class={`fa fa-${props.genericPatients?'user':'paw'}`} aria-hidden="true"></i>
					</div>
					<div class={style.name}>
						{props.firstName ? props.firstName : 'none'}
						&nbsp;{props.lastName}
					</div>
			</Container>
		</div>
	)
}


// WEBPACK FOOTER //
// ./components/groups/PatientSelectCard/index.js